"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _drawerContext = _interopRequireDefault(require("../context/drawer-context"));

var _drawerMobile = _interopRequireDefault(require("../deprecated/drawer-mobile"));

var _drawerDesktop = _interopRequireDefault(require("../deprecated/drawer-desktop"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  z-index: 15;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.54);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// import { transparentize } from 'polished'
var Backdrop = _styledComponents["default"].div(_templateObject());

var DrawerWrapper = function DrawerWrapper(_ref) {
  var isMobile = _ref.isMobile,
      toggleDrawerOnClick = _ref.toggleDrawerOnClick,
      menuItems = _ref.menuItems,
      children = _ref.children,
      defaultOpen = _ref.defaultOpen,
      showBackDrop = _ref.showBackDrop;

  var _useContext = (0, _react.useContext)(_wrapperContext["default"]),
      drawerIsOpen = _useContext.drawerIsOpen,
      toggleDrawer = _useContext.toggleDrawer,
      hideNavBar = _useContext.hideNavBar;

  var _useContext2 = (0, _react.useContext)(_drawerContext["default"]),
      drawerMenuItems = _useContext2.menuItems;

  var contentClasses = "app-wrapper-content ".concat(hideNavBar ? 'hide-nav' : '');
  (0, _react.useEffect)(function () {
    var open = defaultOpen != null ? defaultOpen : !isMobile;
    toggleDrawer(open);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_drawerMobile["default"], {
    isMobile: isMobile,
    toggleDrawerOnClick: toggleDrawerOnClick,
    menuItems: menuItems || drawerMenuItems,
    hidden: !(drawerIsOpen && isMobile),
    toggleDrawer: toggleDrawer
  }), drawerIsOpen && (showBackDrop || isMobile) && /*#__PURE__*/_react["default"].createElement(Backdrop, {
    onClick: toggleDrawer
  }), /*#__PURE__*/_react["default"].createElement(_drawerDesktop["default"], {
    isMobile: isMobile,
    toggleDrawerOnClick: toggleDrawerOnClick,
    menuItems: menuItems || drawerMenuItems,
    hidden: !(drawerIsOpen && !isMobile),
    toggleDrawer: toggleDrawer
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: contentClasses
  }, children));
};

DrawerWrapper.propTypes = {
  isMobile: _propTypes["default"].bool.isRequired,
  toggleDrawerOnClick: _propTypes["default"].bool,
  menuItems: _propTypes["default"].array,
  children: _propTypes["default"].any,
  defaultOpen: _propTypes["default"].bool,
  showBackDrop: _propTypes["default"].bool
};
var _default = DrawerWrapper;
exports["default"] = _default;